import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Form, Button } from "react-bootstrap";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as MapStyles from "../styles/controller.js";

//COMPONENTS
import MainMap from "./MainMap";

function Controller() {
    const dispatch = useDispatch();
    const [key, setKey] = useState("");
    const [mapID, setMapID] = useState("");

    const [saveColor, setSaveColor] = useState("primary");

    const [loadMap, setLoadMap] = useState(false);

    const [data, setData] = useState({
        mapLat: "",
        mapLng: "",
        pinLat: "",
        pinLng: "",
        zoom: ""
    });

    const [mapData, setMapData] = useState({
        mapLat: "",
        mapLng: "",
        pinLat: "",
        pinLng: ""
    });

    const [mapVaild, setMapValid] = useState(false);

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("Map"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("Map"));
        onLoad();
    }, []);

    function onTextChange(event) {
        const { name, value } = event.target;

        const temp = { ...data };

        temp[name] = value;

        setData(temp);
    }

    function onLoad() {
        Axios.post("/pods/mapAdmin/load")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    const newData = {
                        mapLat: data.data.find((setting) => setting.setting == "mapLat").value,
                        mapLng: data.data.find((setting) => setting.setting == "mapLng").value,
                        pinLat: data.data.find((setting) => setting.setting == "pinLat").value,
                        pinLng: data.data.find((setting) => setting.setting == "pinLng").value,
                        zoom: data.data.find((setting) => setting.setting == "zoom").value
                    };
                    setData(newData);

                    reloadMap(newData);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleSave() {
        const sendData = { data: data };

        Axios.post("/pods/mapAdmin/save", sendData)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setSaveColor("success");

                    setTimeout(() => {
                        setSaveColor("primary");
                    }, 2000);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleReload() {
        reloadMap(data);
    }

    function reloadMap(data) {
        setLoadMap(false);
        let isMapValid = true;
        if (data.mapLat == "" || data.mapLng == "" || data.pinLat == "" || data.pinLng == "") {
            isMapValid = false;
        }

        setMapValid(isMapValid);

        if (isMapValid) {
            setMapData({
                mapLat: parseFloat(data.mapLat),
                mapLng: parseFloat(data.mapLng),
                pinLat: parseFloat(data.pinLat),
                pinLng: parseFloat(data.pinLng),
                zoom: parseInt(data.zoom)
            });
        }

        Axios.post("/pods/mapAdmin/getMapData")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    setKey(data.apiKey);
                    setMapID(data.mapID);
                    setLoadMap(true);
                }
            })
            .catch((err) => console.log(err));
    }

    function ShowMap(apiKey) {
        return <div>{console.log(apiKey)}</div>;
    }

    return (
        <div style={MapStyles.body}>
            <div>
                <br />
                <h4>Enter the location of where you want the map</h4>
                <br />
                <Row>
                    <Col>
                        <h5 style={MapStyles.titles}>Map</h5>
                        <br />
                        <Row>
                            <Col sm={3}>
                                <Form.Label>Latitude:</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <Form.Control type="text" name="mapLat" value={data.mapLat} onChange={onTextChange} />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col sm={3}>
                                <Form.Label>Longitude:</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <Form.Control type="text" name="mapLng" value={data.mapLng} onChange={onTextChange} />
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <h5 style={MapStyles.titles}>Pin</h5>
                        <br />
                        <Row>
                            <Col sm={3}>
                                <Form.Label>Latitude:</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <Form.Control type="text" name="pinLat" value={data.pinLat} onChange={onTextChange} />
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col sm={3}>
                                <Form.Label>Longitude:</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <Form.Control type="text" name="pinLng" value={data.pinLng} onChange={onTextChange} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <Row>
                            <Col sm={3}>
                                <Form.Label>Zoom:</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <Form.Control type="text" name="zoom" value={data.zoom} onChange={onTextChange} />
                            </Col>
                        </Row>
                    </Col>
                    <Col style={MapStyles.columnRight}>
                        <Button onClick={handleReload}>Reload</Button>
                        <Button variant={saveColor} style={MapStyles.saveButton} onClick={handleSave}>
                            Save
                        </Button>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        {!mapVaild ? (
                            <div style={MapStyles.mapError}>Please enter all the values above</div>
                        ) : (
                            <div>{loadMap && <MainMap apiKey={key} mapID={mapID} mapData={mapData} />}</div>
                        )}
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default Controller;
